import Sortable from 'sortablejs/Sortable';
export default class PageController {
  constructor(ProductPagesDataProvider, $state) {
    "ngInject"
    this.ProductPagesDataProvider = ProductPagesDataProvider;
    this.$state = $state;
    this.currentPage = 1;
    this.pageLimit = '100';
    this.maxSize = 5;
    this.pageLimitOptions = {10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All'};
    this.type = 1;
    this.field = 'order_by';
    this.order_type = 'asc';
    this.col = 0;
    this.colTopDown = 0;
    this.getCategories();
    let
      el = document.getElementById('items');
    let
      vm = this;
    vm.sortingLog = [];
    let
      sortable = Sortable.create(el, {
        onStart: function (evt) {
          evt.oldIndex;
          console.log('start');
        },
        onEnd: function (evt) {
          let
            oldData = angular.copy(vm.categories);
          let
            i = 0;
          if (evt.oldIndex < evt.newIndex) {
            for (i = evt.oldIndex; i <= evt.newIndex; i++) {
              if (i == evt.newIndex) {
                vm.categories[i] = oldData[evt.oldIndex];
              }
              else {
                vm.categories[i] = oldData[i + 1];
              }
            }
          }
          if (evt.oldIndex > evt.newIndex) {
            for (i = evt.oldIndex; i >= evt.newIndex; i--) {
              if (i == evt.newIndex) {
                vm.categories[i] = oldData[evt.oldIndex];
              }
              else {
                vm.categories[i] = oldData[i - 1];
              }
            }
          }
          vm.categories.map(function (i) {
            vm.sortingLog.push(i.id);
          });
          ProductPagesDataProvider.updateCategoryOrder(vm.sortingLog).then(function (result) {
            vm.getCategories();
          });
          vm.sortingLog = [];
        }
      });
  }

  getSortRecors(field, order_type, col, colTopDown) {
    this.field = field;
    this.order_type = order_type;
    this.col = col;
    this.colTopDown = colTopDown;
    this.getCategories();
  }

  getCategories() {
    let
      vm = this;
    let data = [];
    data.currentPage = vm.currentPage;
    data.pageLimit = vm.pageLimit;
    data.parentId = 0;
    data.field = vm.field;
    data.order_type = vm.order_type;
    vm.ProductPagesDataProvider.getCategory(data).then(function (result) {
      vm.categories = result.data;
      vm.categoriesTotal = result.total;
    });
  }

  removeCategory(id) {
    if (confirm("Are you sure to delete!") !== true) {
      return false;
    }
    let vm = this;
    vm.ProductPagesDataProvider.removeCategory(id, vm.type).then(function (res) {
      vm.getCategories();
    })
  }

  changeStatus(status, id) {
    let
      vm = this;
    let
      data = {'status': status, 'id': id}
    vm.ProductPagesDataProvider.updateCategory(data).then(function (resp) {
      vm.getCategories();
    })
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/product-page/components/category_listing/controller.js
 **/